import { render, staticRenderFns } from "./talk_chushen.vue?vue&type=template&id=d784a61a&scoped=true&"
import script from "./talk_chushen.vue?vue&type=script&lang=js&"
export * from "./talk_chushen.vue?vue&type=script&lang=js&"
import style0 from "./talk_chushen.vue?vue&type=style&index=0&id=d784a61a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d784a61a",
  null
  
)

export default component.exports